// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validate-cart-item-box {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  border-radius: 7px;
  padding: 0.5rem;
}

.validate-content-box {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: gray lightgray;
  height: calc(100vh - 275px);
}

.validate-content-box::-webkit-scrollbar {
  width: 5px;
}

.validate-content-box::-webkit-scrollbar-track {
  background: lightgray;
}

.validate-content-box::-webkit-scrollbar-thumb {
  background-color: gray;
  border-radius: 4px;
}

.validate-content-box::-webkit-scrollbar-thumb:hover {
  background-color: darkgray;
}
.validate-cart-item-left-box {
  /* flex: 0.2; */
  color: red;
  cursor: pointer;
  margin: 0 0.5rem;
}

.validate-cart-item-middle-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.validate-cart-item-count-action {
  cursor: pointer;
}

.validate-cart-item-right-box {
  /* flex: 0.2; */
  font-weight: 600;
}

.validate-cart-item-count-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.items-remaining-box {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.9rem;
}

.items-remaining-count {
  font-weight: 600;
  color: red;
}

.validate-cart-item-count-box {
  display: flex;
  align-items: center;
  gap: 1rem;
  border: 1px solid var(--blue);
  border-radius: 5px;
  padding: 0 0.5rem;
  color: var(--blue);
  font-size: 20px;
  font-weight: 700;
}

.validate-weighing-item-count-box {
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: 5px;
  padding: 2px 0;
  color: var(--blue);
  font-size: 20px;
  font-weight: 700;
}

.validate-weighing-item-count-box > p {
  font-size: 1rem;
}

.validate-cart-item-name {
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.validate-cart-item-loader {
  display: flex;
  color: var(--blue);
}

.validate-form {
  width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leaf-icon {
  width: 25px;
  height: 25px;
  color: green;
  vertical-align: middle;
  margin-right: 5px;
}

.validated-cart-item {
  background-color: #72ff72;
}

.check-icon {
  display: flex;
  position: absolute;
  right: 0.25rem;
  color: #00a82d;
}

.validate-cart-item-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* ── Dark mode ── */
.dark .validate-cart-item-box {
  background: #1e293b;
  box-shadow:
    rgba(0, 0, 0, 0.4) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.5) 0px 3px 7px -3px;
}

.dark .validate-content-box {
  scrollbar-color: #475569 #1e293b;
}

.dark .validate-content-box::-webkit-scrollbar-track {
  background: #1e293b;
}

.dark .validate-content-box::-webkit-scrollbar-thumb {
  background-color: #475569;
}

.dark .validate-content-box::-webkit-scrollbar-thumb:hover {
  background-color: #64748b;
}

.dark .validate-cart-item-name {
  color: #e2e8f0;
}

.dark .validate-cart-item-right-box {
  color: #f1f5f9;
}

.dark .validated-cart-item {
  background-color: #14532d;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/ValidationModal/CartItem.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT;;uCAEqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB;;uCAEqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".validate-cart-item-box {\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n  border-radius: 7px;\n  padding: 0.5rem;\n}\n\n.validate-content-box {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: gray lightgray;\n  height: calc(100vh - 275px);\n}\n\n.validate-content-box::-webkit-scrollbar {\n  width: 5px;\n}\n\n.validate-content-box::-webkit-scrollbar-track {\n  background: lightgray;\n}\n\n.validate-content-box::-webkit-scrollbar-thumb {\n  background-color: gray;\n  border-radius: 4px;\n}\n\n.validate-content-box::-webkit-scrollbar-thumb:hover {\n  background-color: darkgray;\n}\n.validate-cart-item-left-box {\n  /* flex: 0.2; */\n  color: red;\n  cursor: pointer;\n  margin: 0 0.5rem;\n}\n\n.validate-cart-item-middle-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.validate-cart-item-count-action {\n  cursor: pointer;\n}\n\n.validate-cart-item-right-box {\n  /* flex: 0.2; */\n  font-weight: 600;\n}\n\n.validate-cart-item-count-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.items-remaining-box {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.9rem;\n}\n\n.items-remaining-count {\n  font-weight: 600;\n  color: red;\n}\n\n.validate-cart-item-count-box {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  border: 1px solid var(--blue);\n  border-radius: 5px;\n  padding: 0 0.5rem;\n  color: var(--blue);\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.validate-weighing-item-count-box {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  border-radius: 5px;\n  padding: 2px 0;\n  color: var(--blue);\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.validate-weighing-item-count-box > p {\n  font-size: 1rem;\n}\n\n.validate-cart-item-name {\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.validate-cart-item-loader {\n  display: flex;\n  color: var(--blue);\n}\n\n.validate-form {\n  width: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.leaf-icon {\n  width: 25px;\n  height: 25px;\n  color: green;\n  vertical-align: middle;\n  margin-right: 5px;\n}\n\n.validated-cart-item {\n  background-color: #72ff72;\n}\n\n.check-icon {\n  display: flex;\n  position: absolute;\n  right: 0.25rem;\n  color: #00a82d;\n}\n\n.validate-cart-item-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* ── Dark mode ── */\n.dark .validate-cart-item-box {\n  background: #1e293b;\n  box-shadow:\n    rgba(0, 0, 0, 0.4) 0px 6px 12px -2px,\n    rgba(0, 0, 0, 0.5) 0px 3px 7px -3px;\n}\n\n.dark .validate-content-box {\n  scrollbar-color: #475569 #1e293b;\n}\n\n.dark .validate-content-box::-webkit-scrollbar-track {\n  background: #1e293b;\n}\n\n.dark .validate-content-box::-webkit-scrollbar-thumb {\n  background-color: #475569;\n}\n\n.dark .validate-content-box::-webkit-scrollbar-thumb:hover {\n  background-color: #64748b;\n}\n\n.dark .validate-cart-item-name {\n  color: #e2e8f0;\n}\n\n.dark .validate-cart-item-right-box {\n  color: #f1f5f9;\n}\n\n.dark .validated-cart-item {\n  background-color: #14532d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
